import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative h-[420px] md:h-[500px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20panoramic%20art%20collage%20warm%20evening%20scene%20bookshelf%20with%20comics%20cozy%20reading%20nook%20soft%20golden%20lighting%20artistic%20illustration%20style%20warm%20amber%20and%20cream%20tones%20clean%20composition%20inviting%20atmosphere&width=1920&height=1080&seq=cta-bg-hanman&orientation=landscape"
          alt="开始您的韩漫阅读之旅"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 h-full flex items-center px-4 md:px-6">
        <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="flex flex-col gap-5">
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              立即开始您的<br />韩漫阅读之旅
            </h2>
            <Link
              to="/category/action"
              className="inline-flex items-center gap-2 bg-white text-foreground-900 text-sm font-medium px-6 py-3 rounded-full whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors w-fit"
            >
              免费阅读
              <span className="w-5 h-5 flex items-center justify-center bg-foreground-900 rounded-full">
                <i className="ri-arrow-right-line text-xs text-white"></i>
              </span>
            </Link>
          </div>
          <div className="hidden lg:flex items-center justify-end">
            <p className="text-white/80 text-base max-w-sm leading-relaxed">
              每天都有最新韩漫章节上线，<br />与<span className="text-accent-400 font-medium">200万+</span>读者一起享受高品质韩漫阅读体验。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}